const currencySigns = {
  'USD': '$',
  'CAD': 'CAD',
  'EUR': '€',
  'GBP': '£',
  'AMD': '֏',
  'AED': 'AED',
};

export const getCurrencySymbol = (currencyCode) => currencySigns[currencyCode];